import {
  ApplicationConfig,
  DOCUMENT,
  inject,
  LOCALE_ID,
  PLATFORM_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { setupMediaAutoplayBlocker } from './guards/media-autoplay-blocker/media-autoplay-blocker';

import { routes } from './app.routes';

import { provideAuth, StsConfigLoader, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { orgAdminInterceptor } from './interceptors/org-auth-http-interceptor/org-admin.interceptor';
import { errorInterceptor } from './interceptors/error/error.interceptor';
import { AppConfigService } from './services/config/app-config.service';
import { httpLoaderFactory } from './auth/auth.config';
import { AppIconRegistryService } from './services/icon/app-icon-registry.service';
import { isPlatformBrowser } from '@angular/common';

export function initConfig(appConfig: AppConfigService): () => Promise<void> {
  return async () => {
    await appConfig.load();
  };
}

export function disableMediaAutoplay(): void {
  const document = inject(DOCUMENT);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) return;

  setupMediaAutoplayBlocker(document);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(disableMediaAutoplay),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideAuth(
      {
        loader: {
          provide: StsConfigLoader,
          useFactory: httpLoaderFactory,
          deps: []
        }
      },
      withAppInitializerAuthCheck()
    ),
    provideHttpClient(withInterceptors([orgAdminInterceptor, errorInterceptor])),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    AppConfigService,
    provideAppInitializer(() => {
      // Initialize mat icons
      inject(AppIconRegistryService);
      const initializerFn = initConfig(inject(AppConfigService));
      return initializerFn();
    })
  ]
};
